import notificationService from '@app/services/notificationService'

import type { NotificationService } from '@app/services/notificationService/types'

export const useNotification = (): NotificationService => notificationService
